<template>
    <div class="nav-header">
        <div class="header-icon">
            <i class="iconfont icon-zhankaishouqi_left"
               @click="handleCollapseMenu"
               v-if="!collapseMenu"></i>
            <i class="iconfont icon-zhankaishouqi_right-copy"
               @click="handleCollapseMenu"
               v-else></i>
            <img class="logo-img"
                 src="@/assets/imgs/shulanyiyuanLogo.png">
            <span class="logo-text"
                  v-if="hospitalData === 'doctor'">树兰医生端管理后台</span>
            <span class="logo-text"
                  v-if="hospitalData === 'patient'">树兰患者端管理后台</span>
        </div>
        <div class="header-content">
            <el-popover placement="bottom"
                        popper-class="header-user-info"
                        :visible-arrow="false"
                        width="200"
                        @show="showDrop=true"
                        @hide="showDrop=false"
                        trigger="click">
                <div class="user-info-wrap">
                    <div class="user-detail">
                        <div>
                            <span class="user-name">{{ userInfo.accountName|getLast }}</span>
                        </div>
                        <div class="detail">
                            {{ userInfo.accountName}}({{userInfo.accountNumber}})
                        </div>
                    </div>
                    <div class="choose-item-wrap"
                         @click="showHospital=!showHospital">
                        <!-- <div class="choose-item">
                            <i class="iconfont icon-changecompany"></i>
                            <span class="choose-text">切换后台</span>
                            <i class="el-icon-caret-right"></i>
                        </div>
                        <div class="hospital-list"
                             v-if="showHospital">
                            <div class="hospital-item"
                                 @click="handleChangeHospital('doctor')"
                                 :class="{'is-active': hospitalData === 'doctor'}">
                                <span>医生端管理后台</span>
                                <i class="el-icon-check"
                                   v-if="hospitalData === 'doctor'"></i>
                            </div>
                            <div class="hospital-item"
                                 @click="handleChangeHospital('patient')"
                                 :class="{'is-active': hospitalData === 'patient'}">
                                <span>患者端管理后台</span>
                                <i class="el-icon-check"
                                   v-if="hospitalData === 'patient'"></i>
                            </div>
                        </div> -->
                        <div class="choose-item"
                             @click="handleExit">
                            <i class="iconfont icon-outing1"></i>
                            <span class="choose-text">退出登录</span>
                        </div>
                    </div>
                </div>
                <div class="header-item"
                     :class="[{'is-choosed': showDrop}]"
                     slot="reference">
                    <span class="user-name-text">
                        {{ userInfo.accountName }}
                        <i class="el-icon-caret-top user-name-arrow"
                           :class="[{'is-reverse': showDrop}]"></i>
                    </span>
                </div>
            </el-popover>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Navheader',
    inject: ['reload'],
    data () {
        return {
            showDrop: false,
            showHospital: false
            // chooseHospital: 'doctor'
        }
    },
    computed: {
        ...mapGetters([
            'collapseMenu',
            'userInfo',
            'chooseHospital'
        ]),
        hospitalData () {
            let name = 'doctor'
            if (this.chooseHospital) {
                name = this.chooseHospital
            }
            return name
        }
    },
    methods: {
        // 选择切换医院
        handleChangeHospital (name) {
            if (this.chooseHospital !== name) {
                this.$store.dispatch('user/ChooseHospital', name)
                if (name === 'doctor') {
                    this.$router.push('/hospital/hospitalList')
                } else {
                    this.$router.push('/patient/user/userList')
                }
                this.reload()
            }
        },
        handleCollapseMenu () {
            this.$store.dispatch('user/ChangeCollapseMenu', !this.collapseMenu)
        },
        async handleExit () {
            await this.$store.dispatch('user/logout')

            this.$router.push('/login')
        }
    },
    filters: {
        getLast (value) {
            if (value) {
                const arr = value.split('')
                return arr[arr.length - 1]
            } else {
                return ''
            }
        }
    }
}
</script>

<style lang="scss">
.nav-header {
    height: 64px;
    line-height: 64px;
    background-color: $color-primary;
    .header-icon {
        float: left;
        padding-left: 28px;
        font-size: 0;
        height: 64px;
        .iconfont {
            font-size: 13px;
            color: #fff;
            cursor: pointer;
            vertical-align: middle;
        }
        .logo-img {
            margin-left: 34px;
            height: 30px;
            vertical-align: middle;
        }
        .hospitalName {
            font-size: 17px;
            margin-left: 34px;
            color: #fff;
            vertical-align: middle;
        }
        .logo-text {
            display: inline-block;
            height: 24px;
            line-height: 24px;
            border-left: 1px solid #fff;
            padding-left: 16px;
            margin-left: 16px;
            font-size: 18px;
            color: #fff;
            vertical-align: middle;
        }
    }
    .header-content {
        float: right;
        font-size: 0;
        .header-item {
            padding: 0 6px;
            display: inline-block;
            vertical-align: middle;
            font-size: 0px;
            color: #fff;
            margin-right: 14px;
            height: 64px;
            outline: none;
            cursor: pointer;
            span {
                font-size: 14px;
            }
            &.is-choosed {
                background: #36beb7;
            }
        }
        .user-name-text {
            color: #fff;
        }
        .user-name-arrow {
            transform: rotateZ(180deg);
            transition: transform 0.3s, -webkit-transform 0.3s;
            &.is-reverse {
                transform: rotateZ(0deg);
            }
        }

        .user-name {
            display: inline-block;
            width: 32px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border-radius: 16px;
            background-color: #0e6fbb;
            color: #fff;
            vertical-align: middle;
        }
        .icon-xiaoxi {
            color: #33aaff;
            font-size: 14px;
            vertical-align: middle;
        }
        .icon-tuichu {
            color: #f6ac55;
        }
        .item-text {
            vertical-align: middle;
            margin-left: 12px;
        }
        img {
            height: 30px;
            width: 30px;
            border-radius: 15px;
            border: 1px solid #d9d9d9;
            vertical-align: middle;
        }
    }
}
.header-user-info {
    .hospital-list {
        position: absolute;
        top: 17px;
        left: -162px;
        width: 160px;
        background: #ffffff;
        box-shadow: 0 1px 4px 0 rgba(132, 132, 132, 0.5);
    }
    .hospital-item {
        height: 32px;
        line-height: 32px;
        font-size: 12px;
        color: #666;
        padding: 0 10px;
        display: flex;
        cursor: pointer;
        align-items: center;
        &.is-active {
            color: #198eeb;
            justify-content: space-between;
        }
        &:hover {
            background-color: #fffbe0;
        }
        .el-icon-check {
            font-weight: bold;
        }
    }
    &.el-popper[x-placement^="bottom"] {
        margin-top: 0;
        padding: 0;
        box-shadow: 0 1px 4px 0 rgba(132, 132, 132, 0.5);
    }

    .user-detail {
        background-color: #f5f7f8;
        text-align: center;
        padding: 9px 0 13px;
        .user-name {
            display: inline-block;
            width: 32px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border-radius: 16px;
            background-color: $color-primary;
            color: #fff;
        }
        .detail {
            margin-top: 10px;
            font-size: 12px;
            color: #666;
        }
    }

    .choose-item-wrap {
        position: relative;
        .choose-item {
            cursor: pointer;
            height: 40px;
            line-height: 40px;
            padding-left: 14px;
            margin-right: 12px;
        }
        .choose-text {
            font-size: 12px;
            color: #333;
        }
        .iconfont {
            font-size: 14px;
            color: #666;
            margin-right: 9px;
        }
    }
}
</style>
